<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('packages')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
       <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <el-tooltip
            placement="top"
            :effect="theemMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
             <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>
          </el-tooltip>
          <el-tooltip
            placement="top"
            :effect="theemMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('create_package_action')">
              <button
                type="button"
                class="btn btn-primary btn-with-shadow"
                data-toggle="modal"
                @click="openAddEditModal"
                >
                {{ $t("create_package") }}
              </button>
          </el-tooltip>
          
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{$t("instructions_about_package") }}</h5>
          <p class="mb-0">{{$t("introduction_package")}}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("edit") }} :</strong> {{ $t("edit_package_action") }}</li>
            <li><strong>{{ $t("delete") }} :</strong> {{ $t("delete_package_action") }}</li>
            <li><strong>{{ $t("create_form") }} :</strong> {{ $t("create_form_action") }}</li>
            <li><strong>{{ $t("view_forms") }} :</strong> {{ $t("view_form_action") }}</li>
            <li><strong>{{ $t("assign_form") }} :</strong> {{ $t("assign_form_action") }}</li>

          </ul>
        </div>
      </div>
    </div>

    <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
    />

    <packages-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    <package-formassignmodal
      v-if="isFormAssignModalActive"
      :id="id"
      @close-modal="closeFormAssignModal"
    />
    <package-formmodal
      v-if="FormBuilderModal"
      :id="id"
      @close-modal="closeFormBuilderModal"
    />

    <package-forms-modal
      v-if="FormViewModal"
      :id="pack_id"
      @close-modal="closeFormViewModal"
    />

    <package-companies-modal
      v-if="companiesModalActive"
      :package-id="selectedPackageId"
      :package-title="selectedPackageTitle"
      @close-modal="closeCompaniesModal"
    />
  </div>
</template>

<script>
import PackageFormmodal from "./packageformodal.vue";
import PackageCompaniesModal from "./PackageCompaniesModal.vue";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../core/helpers/app/AppFunction";

export default {
  components: { PackageFormmodal, PackageCompaniesModal },
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      instructionShow: false,
      pack_id:0,
      FormViewModal: false,
      FormBuilderModal: false,
      id: 0,
      isFormAssignModalActive: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      companiesModalActive: false,
      selectedPackageId: 0,
      selectedPackageTitle: "",
      options: {
        name: "AdvanceTable",
        url: actions.PACKAGE_LISTING,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
              title: this.$t('title'),
              type: 'media-object',
              key: 'media-object',
              mediaTitleKey: 'title',
              // mediaSubtitleKey: 'amount',
              default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
              modifier: (value, row) => {
                  return AppFunction.getAppUrl(row.image); // imag url
              },
              isVisible: true
          },
          {
            title: this.$t("period"),
            type: "custom-html",
            key: "period",
            modifier: (value,row) => {
              return `<span>${this.$t(row.time_period+' '+value)}</span>`;
            },
          },
          {
            title: this.$t("package_for"),
            type: "custom-html",
            key: "role",
            modifier: (value) => {
              return `<span>${this.$t((value)?value:'---')}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "demo-delete",
          },
          {
            title: this.$t("create_form"),
            icon: "file-plus",
            type: "none",
            component: "package-form-modal",
            modalId: "demo-add-formbuilderbody-Modal",
          },
           {
            title: this.$t("view_forms"),
            icon: "file-plus",
            type: "none",
            component: "package-form-modal",
            modalId: "demo-add-formbuilderbody-Modal",
          },
          {
            title: this.$t("assign_form"),
            icon: "file-plus",
            type: "none",
          },
          {
            title: "View Companies",
            icon: "users",
            type: "none",
            key: "view_companies",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },
    closeFormAssignModal() {
      $("#package-form-assign-Modal").modal("hide");
      this.isFormAssignModalActive = false;
    },
    closeFormBuilderModal() {
      //   $("#package-form-assign-Modal").modal("hide");
      this.FormBuilderModal = false;
    },
    closeFormViewModal() {
      //   $("#package-forms-view-Modal").modal("hide");
      this.FormViewModal = false;
    },
    closeCompaniesModal() {
      this.companiesModalActive = false;
      this.selectedPackageId = 0;
      this.selectedPackageTitle = "";
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      console.log('Action clicked:', actionObj.title, '| rowData id:', rowData.id);

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.PACKAGE_SHOW}/${rowData.id}`;
        this.openAddEditModal();
      } else if (actionObj.title == this.$t("assign_form")) {
        this.id = rowData.id;
        this.isFormAssignModalActive = true;
      } else if (actionObj.title == this.$t("create_form")) {
        this.id = rowData.id;
        this.FormBuilderModal = true;
      }
      else if (actionObj.title == this.$t("view_forms")) {
        this.pack_id = rowData.id;
        this.FormViewModal = true;
      } else if (actionObj.title == this.$t("view_companies") || actionObj.title == "View Companies" || actionObj.key == "view_companies") {
        this.selectedPackageId = rowData.id;
        this.selectedPackageTitle = rowData.title;
        this.companiesModalActive = true;
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
  },
  computed: {
    theemMode() {
      return this.$store.state.theme;
    },
  }
};
</script>
